import { useEffect, useState } from 'react';
import AppLayout from '../components/work/AppLayout';
import InitiativeBoard from '../components/work/InitiativeBoard';
import { fetchInitiativeWorkspace } from '../lib/initiatives';
import type { StateDto } from '../lib/work-types';

export default function Initiatives() {
  const [projectId, setProjectId] = useState<string | undefined>();
  const [states, setStates] = useState<StateDto[]>([]);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    fetchInitiativeWorkspace()
      .then((workspace) => {
        if (cancelled) return;
        setProjectId(workspace.project.id);
        setStates(workspace.states);
      })
      .catch((err: unknown) => {
        if (!cancelled) setError(err instanceof Error ? err.message : 'Failed to open Initiatives');
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <AppLayout>
      <InitiativeBoard projectId={projectId} states={states} error={error} />
    </AppLayout>
  );
}
